import styled from "styled-components";

import {
  ERROR_PRIMARY,
  BORDER_PRIMARY,
  ACTIVE_PRIMARY,
  BACKGROUND_DIM,
  DISABLED_GREY_TEXT,
} from "@/constants/colors";
import { FONT_SIZE_BASE, BODY, REGULAR } from "@/constants/fonts";

const TextInput = styled.input`
  outline: none;
  font-family: ${BODY};
  font-weight: ${REGULAR};
  font-size: ${FONT_SIZE_BASE};
  height: ${({ height }) => (height ? height : "52px")};
  width: ${({ width }) => (width ? width : "100%")};
  text-align: ${({ textAlign }) => (textAlign ? textAlign : "left")};
  padding: 16px;
  border-radius: 2px;
  border: 1px solid ${(props) => (props.isError ? ERROR_PRIMARY : BORDER_PRIMARY)};
  :focus {
    border-color: ${ACTIVE_PRIMARY};
  }
  :disabled {
    color: ${DISABLED_GREY_TEXT};
    background-color: ${BACKGROUND_DIM};
  }
`;

export default TextInput;
